// import React from 'react';
import {useState} from 'react';

function Accordion(props:any) {

    const [isOpen,changeStateOfOpen] = useState<boolean>(props.isOpen)

    /**
     * バーをクリックしたとき、開閉状態を変える
     */
    const onBarClick=()=>{
        if(isOpen){
            changeStateOfOpen(false)
        }else{
            changeStateOfOpen(true)
        }
    }

    return(
        <section className={'accordion ' + props.classForIdentification + ' ' + props.accordionType }>
            <div className="accordion__inner">
                <div className="accordion__ttl" data-is-open={isOpen} onClick={onBarClick}>
                    <h2 className="accordion__ttl-text">
                        {props.title}
                    </h2>
                </div>
                <div className="accordion__content">
                    <div className="accordion__content-inner">
                        <div className="form">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default Accordion;